import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";
import Waveflow from "./WaveFlow";
import WaveFlow2 from "../WaveFlow";
import { useLocation } from "react-router-dom";

const WaveFlowMainPage = () => {
  const [data, setData] = useState([]);

  const location = useLocation();

  // const [tabIndex, setTabIndex] = useState(
  //   location.state?.openWorkflows ? 1 : 0
  // );
  // const [tabIndex, setTabIndex] = useState(() => {
  //   if (location.state?.movetoaicoworker) return 0;
  //   return 0;
  // });
  const [tabIndex, setTabIndex] = useState(0);
  const [editNodeData, seteditNodeData] = useState(
    location?.state?.workflowData
  );

  // 👇 Watch location changes
  useEffect(() => {
    if (location.state?.openWorkflows) {
      setTabIndex(1);
    } else if (location.state?.movetoaicoworker) {
      setTabIndex(0); // Workflows tab
    } else {
      setTabIndex(0); // AI Co-Workers
    }
  }, [location.state]);

  return (
    <Box
      w={"100%"}
      bg="white"
      minH="90vh"
      boxSizing={"border-box"}
      borderRadius={"20px"}
    >
      <Flex>
        <Tabs w={"100%"} index={tabIndex} onChange={(i) => setTabIndex(i)}>
          <TabList w={"100%"}>
            <Tab>AI Co-Workers</Tab>
            <Tab>Workflows</Tab>
          </TabList>
          <TabPanels w={"100%"} p={0} m={0}>
            <TabPanel w={"100%"} h={"85vh"}>
              <Waveflow setData={setData} data={data} />
            </TabPanel>
            <TabPanel p={0} m={0} w={"100%"}>
              {" "}
              <WaveFlow2
                setData={setData}
                data={data}
                editNodeData={editNodeData}
              />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Flex>
    </Box>
  );
};

export default WaveFlowMainPage;
